<template>
  <div class="container my-4 d-flex justify-content-center">
    <Head title="Bienvenida"></Head>
    <div class="col-12 col-md-10 col-lg-6 mx-auto">
      <h1 class="fw-bold lpg-form-title">¡Bienvenido!</h1>
      <h3>👋 Hola, {{ form.fullname.split(' ')[0] }}</h3>
      <p class="text-secondary fs-5 mb-3">
        Te damos la bienvenida al administrador para empresas de nuestra feria de empleos.
      </p>
      <p class="text-secondary fw-bold fs-5 my-1">
        Acá podrás gestionar:
      </p>
      <ul class="text-secondary fs-5">
        <li>
          El stand de tu empresa.
        </li>
        <li>
          Tus ofertas de trabajo.
        </li>
        <li>
          Descargar curriculums de los candidatos (al iniciar la feria)
        </li>
      </ul>
      <p class="fw-bold fs-5">
        Para continuar con el registro necesitamos llenes los siguientes campos:
      </p>
      <form method="post" @submit.prevent="createUserProfile" class="lpg-form">
        <text-input
          v-model="form.fullname"
          label="Nombre completo"
          name="form.fullname"
          :required="true"
          :placeholder="form.fullname"
          :value="form.fullname"
        ></text-input>
        <text-input
          v-model="form.position"
          label="Cargo"
          name="position"
          :required="true"
          placeholder="Senior HR Specialist"
        ></text-input>
        <text-input
          label="Teléfono"
          v-model="form.phone_number"
          name="phone_number"
          type="tel"
          placeholder="7200-0000"
        ></text-input>
        <button class="d-block mx-auto btn btn-secondary mt-4">Continuar</button>
      </form>
    </div>
  </div>
</template>

<script>
import { Head } from '@inertiajs/inertia-vue'
import LayoutEmpresas from '@/Layouts/LayoutEmpresas.vue'
import TextInput from '@/Components/Form/TextInput.vue'

export default {
  name: 'CompanyOnboarding',
  layout: LayoutEmpresas,
  components: {
    Head,
    TextInput,
  },
  props: {
    fullname: String,
  },
  data() {
    return {
      form: {
        fullname: this.fullname,
        phone_number: '',
        position: '',
      },
    }
  },
  methods: {
    createUserProfile() {
      this.$inertia.post(this.$route('company.user.store'), this.form)
    },
  },
}
</script>
